var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _vm.revision
            ? [
                _c("p", [
                  _vm._v("Проверка (" + _vm._s(_vm.revision.id) + ") за "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.printDate(
                          _vm.revision.created_at,
                          "HH:mm DD.MM.YYYY"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.revision.completed_at
                    ? _c("span", [
                        _vm._v(" - продолжительность проверки "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.printRevisionDuration()) + "(s)"),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.revision.completed_at
                  ? [
                      _c(
                        "div",
                        { staticClass: "text-right" },
                        [
                          _c("LoadingButton", {
                            attrs: {
                              title: "Запустить проверку",
                              className: "btn btn-outline-success",
                              onClick: () => _vm.startNewCheck(),
                              loading: _vm.loading,
                              color: _vm.$constants.SUCCESS_COLOR,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : [
                      _c("LoadingButton", {
                        attrs: {
                          title: "Обновить статус проверки",
                          className: "btn btn-outline-info",
                          onClick: () => _vm.refreshCheck(),
                          loading: _vm.loading,
                          color: _vm.$constants.PRIMARY_COLOR,
                        },
                      }),
                    ],
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: { loading: _vm.loading, color: _vm.loadingColor },
          }),
          _vm._v(" "),
          !_vm.loading && _vm.records
            ? _c("div", [
                _c(
                  "table",
                  { staticClass: "table table-sm table-hover mt-2" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (record, i) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(i + 1))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(record.drug.title) +
                                " (" +
                                _vm._s(record.drug.id) +
                                ")"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(record.type_id === 2 ? "Miss" : null)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "(" +
                                _vm._s(record.store_id) +
                                ") " +
                                _vm._s(_vm.$AllStores[record.store_id].title)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(record.calculated_qty))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(record.actual_qty))]),
                          _vm._v(" "),
                          _c("td"),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ошибка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Склад")]),
        _vm._v(" "),
        _c("th", [_vm._v("Просчетный")]),
        _vm._v(" "),
        _c("th", [_vm._v("Актуальный")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }